import React from 'react'
import ParentSubScoreItem from './ParentSubScoreItem'
import { useTranslation } from 'react-i18next'
import './ParentSubScoreList.scss'

const ParentSubScoreList = ({ studentName, subscores }) => {
  const { t } = useTranslation(['teacher_parent_report'])

  if(!subscores) return null

  return (
    <div className="parent-subscore-list-container">
      <h3>{t('{{name}}\'s Reading Subscores', {name: studentName, interpolation: { escapeValue: false },})}</h3>
      <div className="parent-subscore-list">
        <ParentSubScoreItem name={t('Decoding')} values={subscores.decoding}/>
        <ParentSubScoreItem name={t('Phonological Awareness')} values={subscores.phonologicalAwareness}/>
        <ParentSubScoreItem name={t('High Frequency Words')} values={subscores.highFrequencyWords}/>
        <ParentSubScoreItem name={t('Background Knowledge')} values={subscores.backgroundKnowledge}/>
        <ParentSubScoreItem name={t('Structure and Reasoning')} values={subscores.structureAndReasoning}/>
        <ParentSubScoreItem name={t('Vocabulary')} values={subscores.vocabulary}/>
      </div>
    </div>
  )
}

export default ParentSubScoreList